import React from "react"
export function EzcancelIconMono(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <defs>
        <filter
          x="-4.6%"
          y="-4.7%"
          width="109.1%"
          height="108.9%"
          filterUnits="objectBoundingBox"
          id="prefix__filter-2"
        >
          <feOffset dy={-2} in="SourceAlpha" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
            result="shadowInnerInner1"
          />
          <feColorMatrix
            values="0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0.116559222 0"
            in="shadowInnerInner1"
          />
        </filter>
        <path
          d="M.311 2.997C-1.129 12.224 2.43 19.225 10.987 24c8.326-4.394 11.897-11.395 10.712-21.003l-3.654-1.629a17.297 17.297 0 00-14.093.004L.31 2.997z"
          id="prefix__path-1"
        />
      </defs>
      <g
        id="prefix__EZC-Icon-Monochrome"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__EZC">
          <g id="prefix__Logo" transform="translate(1)">
            <g id="prefix__Mask">
              <use fill="currentColor" xlinkHref="#prefix__path-1" />
              <use
                fill="#000"
                filter="url(#prefix__filter-2)"
                xlinkHref="#prefix__path-1"
              />
            </g>
            <path
              d="M10.91 4.79a5.86 5.86 0 015.866 5.857 5.86 5.86 0 01-5.866 5.856 5.86 5.86 0 01-5.865-5.856A5.86 5.86 0 0110.91 4.79zm3.422 4.88H7.489v1.953h6.843V9.67z"
              id="prefix__Combined-Shape-Copy"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
